import { Component } from '@angular/core';

@Component({
    selector: 'app-quick-link-view',
    templateUrl: './quick-link-view.component.html',
    styleUrls: ['./quick-link-view.component.scss'],
    standalone: false
})
export class QuicklinkviewComponent {}
